<template>
  <div id="app">
    <div style="">
    </div>
    <HelloWorld msg="Welcome to Your Vue.js App"/>
    <datenschutzerklaerung></datenschutzerklaerung>
    <badge></badge>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Datenschutzerklaerung from "./components/Datenschutzerklaerung";
import Badge from "./components/Badge";

export default {
  name: 'App',
  components: {
    HelloWorld,
    Datenschutzerklaerung,
    Badge
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4a5568;
  padding: 0;
  margin: 0;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #e53e3e;
  width: 100%;
  min-height: 100vh;
  background-image: url('./assets/pattern.svg'); background-repeat: repeat; background-size: 200px;
}
  body{
    padding: 0;
    margin: 0;
  }
  * {
    box-sizing: border-box;
  }
</style>
